import { Controller } from '../utils/controller';

export default class extends Controller {
  handleLanguageOptionChange(e) {
    window.location.href = e.target.value;
  }
}
